import { toast } from '@/services/toast.js'
import { v4 as uuidv4 } from 'uuid'
import TranslationProvider from '@/provider/translations.js'

export const defaultProperties = [
    {
        "key": "_.helper",
        "required": false,
        "readonly": true,
        "value" : "",
        "type": "text",
        "canDelete": false
    },
    {
        "key": "_.score",
        "required": true,
        "readonly": true,
        "value" : null,
        "type": "number",
        "canDelete": false
    },
]

export function cloneQuestion(data) {
  let newResponses = []
  let additionalProperties = {}

  data['additionalProperties']['select_values'].forEach((el) => {
    newResponses.push({
      'label': el.label,
      'properties': el.properties,
      'value': 'option_' + uuidv4()
    })
  })

  additionalProperties.select_values = newResponses;

  if (data['type'] === 'numeric') {

    const min = data.additionalProperties.range.min ?? null;
    const max = data.additionalProperties.range.max ?? null;

    if (!additionalProperties.range) {
      additionalProperties.range = {};
    }

    if (min !== null) {
      additionalProperties.range.min = min;
    }

    if (max !== null) {
      additionalProperties.range.max = max;
    }
  }

  return {
    'parentQuestionGroup': data['parentQuestionGroup'],
    'helper': data['helper'],
    'required': data['required'],
    'text': data['text'],
    'type': data['type'],
    'hasNote': data['hasNote'],
    'position': newResponses.length + 1,
    'additionalProperties' : additionalProperties
  }
}

export function cloneOptions(option) {
  const newOption = {
    label: option.label,
    properties: [],
    value: 'option_' + uuidv4()
  };

  if (option?.properties.length) {
    for (const property of option?.properties) {
      const dProperty = defaultProperties.find(defProp => defProp.key === property.key)

      const prop = {
        'key': property.key,
        'value': !property.value || property.value.toString().trim() === "" ? dProperty.value : property.value,
      }
      newOption['properties'].push(prop)
    }
  }

  return newOption;
}

export function validateProperty(property) {
  let value = property.value
  const dProperty = defaultProperties.find(defProp => defProp.key === property.key)

  if (value === null || value.toString().trim() === "") {
    if (dProperty.required) {
      const msg = TranslationProvider.getTrans("app.error.defaultProperty.value.missing", null, {'{{property}}': property.key})
      throw new Error(msg)
    }
    value = defaultProperties.find(defProp => defProp.key === property.key).value
  }

  return value;
}

export function addOption() {
  const value = 'option_' + uuidv4();
  const option = {
    'label': '',
    'value': value,
    'properties': []
  };

  if (defaultProperties.length){
    for (const defaultProperty of defaultProperties) {
      const prop = {
        'key':  defaultProperty.key,
        'value': defaultProperty.value,
      };
      option['properties'].push(prop)
    }
  }

  return option;
}

export const validateNumberQuestion = (min = null, max = null) => {

    let range = {}

    let minValue = parseFloat(min) ?? null
    let maxValue = parseFloat(max) ?? null

    if (minValue >= maxValue) {
      toast.create('Il valore minimo deve essere inferiore al massimo', 'error')
      return false
    }

    range.min = minValue
    range.max = maxValue

    return range;
}

export const requiredProperty = (property) => {
  const dProperty = defaultProperties.find(defProp => defProp.key === property.key);
  if (!dProperty) {
    return false;
  }

  if (dProperty.required) {
    if (property.value === null || property.value.toString().trim() === ""){
      return true
    }
  }

  return false;
}
